export default "__VITE_ASSET__BnmV2w3U__"